import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

let url = wixLocation.url

$w.onReady(function () {

  if (url === "https://www.doob.eu/doob-world"){
$w("#doobworld").show();
$w("#franchisemenu").hide();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/vr"){
$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").show()
}

if (url === "https://www.doob.eu/vr?lang=de"){
$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").show()
}

if (url === "https://www.doob.eu/vr?lang=en"){
$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").show()
}

if (url === "https://www.doob.eu/doob-world?lang=de"){
$w("#doobworld").show();
$w("#franchisemenu").hide();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/doob-world?lang=en"){
$w("#doobworld").show();
$w("#franchisemenu").hide();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}


if (url === "https://www.doob.eu/franchise"){
	$w("#doobworld").hide();
$w("#franchisemenu").show();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

if (url === "https://www.doob.eu"){
	$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").show();
$w("#doobcenter").hide();
$w("#doobmainfooter").show()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/franchise?lang=de"){
	$w("#doobworld").hide();
$w("#franchisemenu").show();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/?lang=de"){
$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").show();
$w("#doobcenter").hide();
$w("#doobmainfooter").show()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/franchise?lang=en"){
	$w("#doobworld").hide();
$w("#franchisemenu").show();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/?lang=en"){
	$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}


if (url === "https://www.doob.eu/doob-world"){
$w("#doobworld").show();
$w("#franchisemenu").hide();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/vr"){
$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").show()
}

if (url === "https://www.doob.eu/vr?lang=de"){
$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").show()
}

if (url === "https://www.doob.eu/vr?lang=en"){
$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").show()
}

if (url === "https://www.doob.eu/doob-world?lang=de"){
$w("#doobworld").show();
$w("#franchisemenu").hide();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/doob-world?lang=en"){
$w("#doobworld").show();
$w("#franchisemenu").hide();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}


if (url === "https://www.doob.eu/franchise"){
	$w("#doobworld").hide();
$w("#franchisemenu").show();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

if (url === "https://www.doob.eu"){
	$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").show();
$w("#doobcenter").hide();
$w("#doobmainfooter").show()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/franchise?lang=de"){
	$w("#doobworld").hide();
$w("#franchisemenu").show();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/?lang=de"){
$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").show();
$w("#doobcenter").hide();
$w("#doobmainfooter").show()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/franchise?lang=en"){
	$w("#doobworld").hide();
$w("#franchisemenu").show();
$w("#mainmenu").hide();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

if (url === "https://www.doob.eu/?lang=en"){
	$w("#doobworld").hide();
$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").hide();
$w("#doobcenter").show()
$w("#doobmainfooter").hide()
$w("#vr").hide()
}

});



export function button21_click(event) {
	$w("#franchisemenu").hide();
$w("#mainmenu").show();
$w("#group5").show();
$w("#doobcenter").hide();
$w("#doobmainfooter").show()
wixLocation.to("/home")
}

export function button34_click(event) {
		$w("#doobworld").hide();
$w("#mainmenu").show();
$w("#group5").show();
$w("#doobcenter").hide();
$w("#doobmainfooter").show()
wixLocation.to("/home")
}

export function doobmainfooter_click(event) {
	//Add your code for this event here: 
}

export function doobcenter_click(event) {
$w("#franchisemenu").hide();
$w("#doobworld").hide();
$w("#mainmenu").show();
$w("#group5").show();
$w("#doobcenter").hide();
$w("#doobmainfooter").show()
wixLocation.to("/home")
}



export function button46_click(event) {
			$w("#vr").hide();
$w("#mainmenu").show();
$w("#group5").show();
$w("#doobcenter").hide();
$w("#doobmainfooter").show()
wixLocation.to("/home") 
}

export function button14_click(event) {
if(wixWindow.formFactor === "Mobile"){
 wixLocation.to("/impressum-mobile") 
  }
else {
$w("#imprint").show();
}
	
}


export function button13_click(event) {
	
if(wixWindow.formFactor === "Mobile"){
 wixLocation.to("/datenschutz-mobile") 
  }
else {
$w("#datenschutz").show();
}


}

export function vectorImage8_click(event) {
	$w("#datenschutz").hide();
}

export function vectorImage5_click(event) {
	$w("#imprint").hide();
}